var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppviewWithNavigationAndTabs',{attrs:{"center":""}},[_c('div',{staticClass:"w-full flex flex-row flex-wrap justify-center align-center md:w-2/3 lg:w-6/12 mx-auto my-12"},[_c('UpdateDnsRecordForm',{staticClass:"w-full"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }